import { render, staticRenderFns } from "./im-video-file-message.vue?vue&type=template&id=55298008&scoped=true"
import script from "./im-video-file-message.vue?vue&type=script&lang=js"
export * from "./im-video-file-message.vue?vue&type=script&lang=js"
import style0 from "./im-video-file-message.vue?vue&type=style&index=0&id=55298008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55298008",
  null
  
)

export default component.exports